import apiClient from './client'
import type { AuthResponse } from '../types/module.types'

interface LoginPayload {
  email: string
  password: string
}

interface RegisterPayload {
  email: string
  password: string
  name: string
}

/**
 * Authentication API functions.
 *
 * All functions communicate exclusively through the centralized apiClient.
 * Error handling (401, 409, etc.) is done in the calling component/hook
 * by catching ApiError instances.
 */
export const authApi = {
  /** Register a new user account */
  register: async (payload: RegisterPayload): Promise<AuthResponse> => {
    const { data } = await apiClient.post<AuthResponse>('/api/auth/register', payload)
    return data
  },

  /** Login with email and password */
  login: async (payload: LoginPayload): Promise<AuthResponse> => {
    const { data } = await apiClient.post<AuthResponse>('/api/auth/login', payload)
    return data
  },

  /**
   * Silently refresh the access token.
   * The browser sends the HttpOnly refresh token cookie automatically.
   */
  refresh: async (): Promise<AuthResponse> => {
    const { data } = await apiClient.post<AuthResponse>('/api/auth/refresh')
    return data
  },

  /** Logout — revokes all sessions, clears the refresh token cookie */
  logout: async (): Promise<void> => {
    await apiClient.post('/api/auth/logout')
  },
}
